import React from 'react';
import { RedirectData } from '@hooks/useChat';
import './PdfListOverlay.scss';
import { ChevronLeftIcon, ChevronRightIcon, UserManualIcon } from '@assets/icon';

interface PdfListOverlayProps {
  data: RedirectData;
  onClose: () => void;
}

const PdfListOverlay: React.FC<PdfListOverlayProps> = ({ data, onClose }) => {

  // Get title based on type
  const getTitle = () => {
    switch (data.type) {
      case 'tax_handbook':
        return 'Tra cứu sổ tay thuế';
      case 'lump_tax':
        return '60 ngày xóa bỏ thuế khoán';
      default:
        return data.commandName || 'Tài liệu';
    }
  };

  return (
    <div className="pdf-panel-fullscreen">
      <div className="pdf-panel-header">
        <button
          className="pdf-panel-back-btn"
          onClick={onClose}
          aria-label="Quay lại"
        >
          <ChevronLeftIcon className="pdf-panel-back-arrow" />
        </button>
        <span className="pdf-panel-title">{getTitle()}</span>
      </div>
      <div className="pdf-panel-list-container">
        {data.items.map((item, index) => (
          <button
            key={index}
            className="pdf-panel-item"
            onClick={() => window.open(item.uri, '_blank')}
          >
            <span className="pdf-panel-item-icon">
              <UserManualIcon />
            </span>
            <span className="pdf-panel-item-title">{item.title}</span>
            <ChevronRightIcon className="pdf-panel-item-arrow" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default PdfListOverlay;
